export default __webpack_public_path__ + "static/media/send_active.d19faa24.svg";